import { render, staticRenderFns } from "./CardScaffoldContractors.vue?vue&type=template&id=5896ce31"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5896ce31')) {
      api.createRecord('5896ce31', component.options)
    } else {
      api.reload('5896ce31', component.options)
    }
    module.hot.accept("./CardScaffoldContractors.vue?vue&type=template&id=5896ce31", function () {
      api.rerender('5896ce31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardScaffoldContractors.vue"
export default component.exports